module.exports = __webpack_public_path__ + "static/media/1_A1_13.f7d2bb25.png";